var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCraneConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.1 112.5H37.5V132.52H101.1V112.5Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.557006,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 86.5H119.8V91.84H136.5V86.5Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.742675,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 73.7H2.59998V112.32H22.6V73.7Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.557006,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.2 39.7999H52.4L72.8 29.2L137.2 39.7999Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.557006,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.7 112.3H127.3V132.67H147.7V112.3Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.557006,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 74.0999V34.1999L35.9 20.8999V92.4999",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 29V34.6",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 49V54.6",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 39V44.6",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 36.3999V86.4999",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1 28.3999V112.5",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7 29.0999V112.5",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2999 111.9L79.3999 87.7998L68.2999 63.7998",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 63.8999L68.4 87.9999L79.5 112",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4 63.6L79.5 39.5",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2 39.7L79.4 63.7",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112 131.9H54.4",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2 116.5H41.5",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 116.5H51.5",
    stroke: "#1F323D",
    strokeWidth: 0.742675,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraneConstruction);
export default __webpack_public_path__ + "static/media/crane_construction.4870fa37982821fe6f7a06cbca9e31c6.svg";
export { ForwardRef as ReactComponent };